import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createSlots as _createSlots, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-wizard-header": "",
  class: "-mx-4 -my-1.5 flex min-w-0 flex-1 items-center justify-between gap-4 bg-white px-6 py-3.5 md:px-7"
}
const _hoisted_2 = { class: "flex min-w-0 flex-col gap-0.5" }
const _hoisted_3 = {
  "aria-label": "Breadcrumb",
  class: "text-[13px] text-gray-500"
}
const _hoisted_4 = { class: "flex min-w-0 items-center gap-2.5" }
const _hoisted_5 = {
  "data-top": "",
  class: "m-0 truncate pb-0.5 text-[22px] font-bold leading-snug tracking-[-0.02em] text-gray-900"
}
const _hoisted_6 = {
  key: 0,
  "data-draft-pill": "",
  class: "flex-shrink-0 rounded-full bg-[#fef3c7] px-[9px] py-[3px] text-xs font-semibold text-[#92400e]"
}
const _hoisted_7 = { class: "flex flex-shrink-0 items-center gap-2" }
const _hoisted_8 = { class: "flex h-full bg-[#f6f7f9]" }
const _hoisted_9 = { class: "flex min-h-0 min-w-0 flex-1 flex-col" }
const _hoisted_10 = { class: "flex-1 overflow-y-auto px-6 py-9 md:px-10" }
const _hoisted_11 = { class: "mx-auto max-w-[920px]" }
const _hoisted_12 = { class: "flex flex-col gap-1.5 pb-7" }
const _hoisted_13 = {
  "data-eyebrow": "",
  class: "m-0 text-[13px] font-semibold text-gray-500"
}
const _hoisted_14 = {
  "data-step-question": "",
  class: "m-0 text-2xl font-bold tracking-[-0.02em] text-gray-900"
}
const _hoisted_15 = {
  key: 0,
  class: "m-0 mt-1 max-w-2xl text-sm leading-relaxed text-gray-600"
}
const _hoisted_16 = { "data-step": "" }
const _hoisted_17 = {
  key: 0,
  "data-wizard-footer": "",
  class: "border-t border-gray-200 bg-white px-6 py-3.5 md:px-12"
}

import { ref } from 'vue'

import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardRail from '@/components/neue/wizard/WizardRail.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'


export default {
  __name: 'WizardShell',
  props: {
  title: { type: String, required: true },
  crumbLabel: { type: String, required: true },
  crumbTo: { type: String, required: true },
  crumbCurrent: { type: String, required: true },
  draftLabel: { type: String, default: '' },
  eyebrow: { type: String, default: '' },
  heading: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  railRows: { type: Array, default: () => [] },
  railTitle: { type: String, default: 'Setup' },
  railButtonLabel: { type: String, default: 'Setup' }
},
  emits: ['cancel', 'jump'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const railOpen = ref(false)

const jump = key => {
  emit('jump', key)
  railOpen.value = false
}

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(SecondaryNav, { "full-width": "" }, {
    top: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: __props.crumbTo,
              class: "hover:text-gray-900"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.crumbLabel), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _cache[3] || (_cache[3] = _createElementVNode("span", {
              "aria-hidden": "true",
              class: "mx-1"
            }, "/", -1)),
            _createElementVNode("span", null, _toDisplayString(__props.crumbCurrent), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.title), 1),
            (__props.draftLabel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.draftLabel), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(WizardButton, {
            class: "min-[1100px]:hidden",
            "aria-expanded": railOpen.value,
            onClick: _cache[0] || (_cache[0] = $event => (railOpen.value = !railOpen.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.railButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["aria-expanded"]),
          _createVNode(WizardButton, {
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('cancel')))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(__props.eyebrow), 1),
                _createElementVNode("h2", _hoisted_14, _toDisplayString(__props.heading), 1),
                (__props.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(__props.subtitle), 1))
                  : _createCommentVNode("", true)
              ]),
              _renderSlot(_ctx.$slots, "banner"),
              _createElementVNode("div", _hoisted_16, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ]),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ]),
        (railOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-30 bg-black/20 min-[1100px]:hidden",
              onClick: _cache[2] || (_cache[2] = $event => (railOpen.value = false))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          "data-so-far": "",
          class: _normalizeClass(["w-80 flex-shrink-0 border-l border-gray-200 bg-white min-[1100px]:static min-[1100px]:block min-[1100px]:shadow-none", railOpen.value ? 'fixed inset-y-0 right-0 z-40 overflow-y-auto shadow-xl' : 'hidden'])
        }, [
          _createVNode(WizardRail, {
            rows: __props.railRows,
            title: __props.railTitle,
            onJump: jump
          }, _createSlots({ _: 2 }, [
            (_ctx.$slots['rail-foot'])
              ? {
                  name: "default",
                  fn: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "rail-foot")
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["rows", "title"])
        ], 2)
      ])
    ]),
    _: 3
  }))
}
}

}